import React from "react";
import PagesIcon from '@material-ui/icons/Pages';
// import WbIncandescentIcon from '@material-ui/icons/WbIncandescent';
// import EventNoteIcon from '@material-ui/icons/EventNote';
// import NoteIcon from '@material-ui/icons/Note';
// import BlurOnIcon from '@material-ui/icons/BlurOn';
function Header() {
  return (
    <header>
      <h1>
      <PagesIcon />
      &#160;Keeper
      </h1>
    </header>
  );
}

export default Header;
